import { Chart } from 'primereact/chart'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import SwitchButtonComponent from '../../chart-components/single-selection-button/SwitchButtonComponent'

const FullnessBarChart = (props: { colors: string[]; response: any; userInfo: any }) => {
  const { t } = useTranslation()
  const [selected, setSelected] = useState<any>(t('dashboard.count'))

  const addEmptyLabels = (array: any) => {
    const maxCount = props.userInfo === 'LocationAdmin' ? 10 : 6
    if (array && array.length > 0 && array.length < 5) {
      for (let i = 0; i < maxCount - array.length; i++) {
        array.push('')
      }
    }

    return array
  }
  const labels = addEmptyLabels(props.response?.stackedItems.labels)
  const initialWord = t('dashboard.count')
  const basicData = {
    labels: labels,
    datasets: [
      {
        label: t('dashboard.occupancy'),
        backgroundColor: props.colors[0],
        data:
          selected === initialWord ? props.response?.stackedItems.count[0] : props.response?.stackedItems.percentage[0],
      },
    ],
  }
  let basicOptions = {
    maintainAspectRatio: false,
    aspectRatio: 0.8,
    plugins: {
      legend: {
        display: false,
      },
    },
    datasets: {
      bar: {
        barThickness: 'flex',
        barPercentage: 0.7,
        categoryPercentage: 1,
      },
    },
    scales: {
      x: {
        ticks: {
          color: '#495057',
          minRotation: 90,
          font: {
            family: "'Inter', serif",
            size: 12,
          },
        },
        grid: {
          color: '#ebedef',
        },
      },
      y: {
        ticks: {
          color: '#495057',
        },
        grid: {
          color: '#ebedef',
        },
      },
    },
  }
  return (
    <>
      <div className="d-flex justify-content-between">
        <div
          style={{
            fontWeight: 'bold',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            marginLeft: '1rem',
            fontStyle: 'italic',
          }}>
          <span style={{ marginRight: '2rem', fontWeight: 'bold', fontSize: '1rem' }}>
            {selected === 'Yüzde' && '%'}{' '}
          </span>

          <span className="d-block ml-3">{t('dashboard.firm-office-tooltip-text')}</span>
        </div>

        <div style={{ display: 'flex' }}>
          <SwitchButtonComponent selected={selected} setSelected={setSelected} unselectable={false} />
        </div>
      </div>
      <div className="scroll">
        <Chart
          type="bar"
          data={basicData}
          options={basicOptions}
          style={{ minWidth: '60rem', overflowX: 'auto', width: `${labels?.length * 80}px` }}
        />
      </div>
    </>
  )
}

export default FullnessBarChart
